module.exports = __webpack_public_path__ + "img/data_presensi.feabff3a.png";